import React from "react";
import { withRouter } from "react-router-dom";

// Shared Finance-style tab bar that links the three Material modules.
const TABS = [
    { key: "assigning", label: "Assigning", icon: "fal fa-clipboard-list", path: "/material-assigning" },
    { key: "report", label: "Report", icon: "fal fa-file-alt", path: "/material-report" },
    { key: "store", label: "Store", icon: "fal fa-warehouse", path: "/material-store" },
];

const MaterialTabs = ({ active, history }) => (
    <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "12px 24px 0 24px" }}>
        <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8 }}>
            {TABS.map((tab) => {
                const isActive = active === tab.key;
                return (
                    <li className="nav-item" key={tab.key}>
                        <a
                            className={`nav-link ${isActive ? "active" : ""}`}
                            href={tab.path}
                            onClick={(e) => { e.preventDefault(); if (!isActive) history.push(tab.path); }}
                            style={{
                                cursor: "pointer",
                                fontWeight: 700,
                                fontSize: 14,
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                padding: "12px 20px",
                                color: isActive ? "#6366f1" : "#4b5563",
                                background: isActive ? "#fff" : "transparent",
                                borderColor: isActive ? "#e2e8f0 #e2e8f0 #fff" : "transparent",
                                borderWidth: "1.5px",
                                borderBottomWidth: isActive ? "2px" : "1.5px",
                                borderRadius: "10px 10px 0 0",
                                transition: "all 0.15s ease",
                                marginBottom: "-1.5px",
                                textDecoration: "none",
                            }}
                        >
                            <i className={tab.icon} />
                            {tab.label}
                        </a>
                    </li>
                );
            })}
        </ul>
    </div>
);

export default withRouter(MaterialTabs);
